import { CommonUIModule } from '../webpack';
/** @component React Components */
export const SliderField = Object.values(CommonUIModule).find((mod) => 
// stable || beta as of oct 2 2024
mod?.toString?.()?.includes('SliderField,fallback') || mod?.toString?.()?.includes('SliderField",'));
